<template>
  <div>
    <span>PatAppointmentsBPage</span>
    <v-overlay-loader />
  </div>
</template>

<script>
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';

export default {
  components: {
    VOverlayLoader,
  },
};
</script>
